module.exports = __webpack_public_path__ + "static/media/texture.cbf1f1f1.png";